import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-bg px-6 text-center">
      <SEO
        title="403 – Adgang nægtet"
        description="Du har ikke tilladelse til at tilgå denne side hos Pabst Teknik ApS."
        noindex={true}
      />
      <div className="mx-auto max-w-md flex flex-col items-center gap-6">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-amber-50 text-amber-500 border border-amber-100 shadow-sm">
          <i className="fa-regular fa-circle-exclamation text-4xl" />
        </div>
        <h1 className="text-4xl font-extrabold text-brand-dark sm:text-5xl">403</h1>
        <h2 className="text-xl font-bold text-slate-800">Adgang nægtet</h2>
        <p className="text-sm text-slate-500 leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte administratoren.
        </p>
        <Link
          to="/"
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand-accent px-8 py-3.5 text-sm font-bold text-white shadow-md transition-all hover:bg-brand-accent-hover"
        >
          <i className="fa-regular fa-house" />
          <span>Gå til forsiden</span>
        </Link>
      </div>
    </div>
  );
}
